import deleteIcon from './../assets/images/trash.png';
import folderIcon from './../assets/images/folder.png';
import infoIcon from './../assets/images/info.png';
import starIcon from './../assets/images/star-2.png';
import replyAllIcon from './../assets/images/replyAll.png';
import replyRight from './../assets/images/forward.png';
import replyIcon from './../assets/images/reply.png';

const Tools = () => {
  return (
    <div className="h-14 border border-border-light flex items-center gap-[50px] px-4 bg-white">
      <button className="flex items-center justify-center">
        <img src={deleteIcon} alt="Delete" className="h-5 w-5" />
      </button>
      <button className="flex items-center justify-center">
        <img src={folderIcon} alt="Folder" className="h-5 w-5" />
      </button>
      <button className="flex items-center justify-center">
        <img src={infoIcon} alt="Info" className="h-5 w-5" />
      </button>
      <button className="flex items-center justify-center">
        <img src={starIcon} alt="Star" className="h-5 w-5" />
      </button>
      <button className="flex items-center justify-center">
        <img src={replyIcon} alt="Reply" className="h-5 w-5" />
      </button>
      <button className="flex items-center justify-center">
        <img src={replyAllIcon} alt="Reply" className="h-5 w-5" />
      </button>
      <button className="flex items-center justify-center">
        <img src={replyRight} alt="Forward" className="h-5 w-5" />
      </button>
    </div>
  );
};

export default Tools;
